import AppSettingsType from './types/AppSettings.type';

const config = process.env;

const defaultSettings: AppSettingsType = {
    env: '',
    OIDC_PROVIDER: '',
    OIDC_CLIENT_ID: '',
    OIDC_REDIRECT_ROUTE: '',
    OIDC_END_SESSION_ENDPOINT: '',
    APIM_URL: '',
    APPINSIGHTS_CONNECTIONSTRING: '',
};

const appSettings: AppSettingsType = (() => {
    if (config.REACT_APP_ENV === 'DEV') {
        return {
            env: config.REACT_APP_ENV,
            OIDC_PROVIDER: config.REACT_APP_DEV_OIDC_PROVIDER,
            OIDC_CLIENT_ID: config.REACT_APP_DEV_OIDC_CLIENT_ID,
            OIDC_REDIRECT_ROUTE: config.REACT_APP_DEV_OIDC_REDIRECT_ROUTE,
            OIDC_END_SESSION_ENDPOINT: config.REACT_APP_DEV_OIDC_END_SESSION_ENDPOINT,
            APIM_URL: config.REACT_APP_DEV_MARGINAL_WEATHER_APIM_BASE_URL,
            APPINSIGHTS_CONNECTIONSTRING: config.REACT_APP_DEV_APPINSIGHTS_CONNECTIONSTRING,
        };
    } else if (config.REACT_APP_ENV === 'TEST') {
        return {
            env: config.REACT_APP_ENV,
            OIDC_PROVIDER: config.REACT_APP_TEST_OIDC_PROVIDER,
            OIDC_CLIENT_ID: config.REACT_APP_TEST_OIDC_CLIENT_ID,
            OIDC_REDIRECT_ROUTE: config.REACT_APP_TEST_OIDC_REDIRECT_ROUTE,
            OIDC_END_SESSION_ENDPOINT: config.REACT_APP_TEST_OIDC_END_SESSION_ENDPOINT,
            APIM_URL: config.REACT_APP_TEST_MARGINAL_WEATHER_APIM_BASE_URL,
            APPINSIGHTS_CONNECTIONSTRING: config.REACT_APP_TEST_APPINSIGHTS_CONNECTIONSTRING,
        };
    } else if (config.REACT_APP_ENV === 'QA') {
        return {
            env: config.REACT_APP_ENV,
            OIDC_PROVIDER: config.REACT_APP_QA_OIDC_PROVIDER,
            OIDC_CLIENT_ID: config.REACT_APP_QA_OIDC_CLIENT_ID,
            OIDC_REDIRECT_ROUTE: config.REACT_APP_QA_OIDC_REDIRECT_ROUTE,
            OIDC_END_SESSION_ENDPOINT: config.REACT_APP_QA_OIDC_END_SESSION_ENDPOINT,
            APIM_URL: config.REACT_APP_QA_MARGINAL_WEATHER_APIM_BASE_URL,
            APPINSIGHTS_CONNECTIONSTRING: config.REACT_APP_QA_APPINSIGHTS_CONNECTIONSTRING,
        };
    } else if (config.REACT_APP_ENV === 'PROD') {
        return {
            env: config.REACT_APP_ENV,
            OIDC_PROVIDER: config.REACT_APP_PROD_OIDC_PROVIDER,
            OIDC_CLIENT_ID: config.REACT_APP_PROD_OIDC_CLIENT_ID,
            OIDC_REDIRECT_ROUTE: config.REACT_APP_PROD_OIDC_REDIRECT_ROUTE,
            OIDC_END_SESSION_ENDPOINT: config.REACT_APP_PROD_OIDC_END_SESSION_ENDPOINT,
            APIM_URL: config.REACT_APP_PROD_MARGINAL_WEATHER_APIM_BASE_URL,
            APPINSIGHTS_CONNECTIONSTRING: config.REACT_APP_PROD_APPINSIGHTS_CONNECTIONSTRING,
        };
    } else {
        return { ...defaultSettings };
    }
})();

export { appSettings };
